<template>
    <div id="my_tablepanel">
        <div class="operation" v-if="tables.operation && tables.operation.length>0">
            <div v-for="opr,i in tables.operation">
              <div class="options_icon" v-if="opr.icon"
                @click="opr.event(selectItems)"
                @mouseenter="mouseIsIn(true,i)" 
                @mouseleave="mouseIsIn(true)">
                <div class="icons clearfix">
                  <i v-if="opr.icon === 'del'" :style="{background:'url('+delIcon+')'}"></i>
                  <i v-if="opr.icon === 'edit'" :style="{background:'url('+editIcon+')'}"></i>
                  <i v-if="opr.icon === 'export'" :style="{background:'url('+exportIcon+')'}"></i>
                  <i v-if="opr.icon === 'printing'" :style="{background:'url('+printIcon+')'}"></i>
                </div>
                <span class="options_name" v-show="mouseIn === i">{{opr.name}}</span>
              </div>
              <!-- <div v-else class="my_button" :style="opr.name=='返回'?{backgroundColor:'#ecf5ff',color:'#458FD9',borderColor:'#458FD9'}:{}" style="margin-right:10px" @click="opr.event(selectItems)">{{opr.name}}</div> -->
              <el-button 
                  v-else
                  size="mini" 
                  type="primary" 
                  :plain="opr.name=='返回'"
                  @click="opr.event(selectItems)"
                  style="margin-right: 10px;">{{opr.name}}</el-button>
            </div>
        </div>
        <div>
            <el-table
                v-if="tables.isAdaption"
                ref="multipleTable"
                style="width: 100%;"
                :data="tables.tbody.slice(0,tables.limit?tables.limit:tables.tbody.length)" 
                stripe 
                border
                :summary-method="tables.summaryEvent"
                :show-summary="tables.showSummary"
                :sum-text="tables.summaryText||'合计'"
                :empty-text="' '"
                @sort-change="sort"
                @selection-change="handleSelectionChange">
                <div v-for="(head,hindex) in tables.thead">
                    <el-table-column v-if="head.name === '选择' || head.name === 'select'" type="selection" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.name === '序号' || head.name === 'sort'" type="index" label="序号"  :width="head.width || '60px'" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.attr" :prop="head.attr" :label="head.name" :sortable="head.sort" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed">
                      <template slot-scope="scope">
                        <div v-if="head.imgUrl">
                          <img style="width:40px;height:40px" :src="gfUrl+scope.row[head.imgUrl]">
                        </div>
                         <p
                          v-else-if="head.format"
                          class="row_text"
                          >{{head.format(scope.row[head.attr])}}</p>
                        <div v-else>
                          <p v-if="head.filter" class="row_text">{{scope.row[head.attr] | switchType(head.filter[0],head.filter[1])}}</p>
                          <p v-else class="row_text">{{scope.row[head.attr]}}</p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="head.date" :prop="head.date" :label="head.name" :sortable="head.sort" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.buttons" :fixed="head.fixed || 'right'" label="操作" :width="head.width">
                    <template slot-scope="scope">
                        <span v-for="btn in head.buttons">
                        <el-button @click="btn.event(scope.row)" v-show="btn.show || true" type="text" :style="{color:btn.name==='删除'?'red':''}" size="small">{{btn.name}}</el-button>
                        <!-- <el-button @click="btn.event(scope.row)" :type="btn.type" size="mini">{{btn.name}}</el-button> -->
                        </span>
                    </template>
                    </el-table-column>
                </div>
            </el-table>
            <el-table
                v-else
                ref="multipleTable"
                style="width: 100%;"
                v-loading="tableLoading"
                :data="tables.tbody" 
                :height="tabHeight || tableHeight" 
                stripe 
                border
                :summary-method="tables.summaryEvent"
                :show-summary="tables.showSummary"
                :sum-text="tables.summaryText||'合计'"
                :empty-text="' '"
                @selection-change="handleSelectionChange">
                <div v-for="(head,hindex) in tables.thead">
                    <el-table-column v-if="head.name === '选择' || head.name === 'select'" type="selection" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.name === '序号' || head.name === 'sort'" type="index" label="序号"  :width="head.width || '60px'" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.attr" :prop="head.attr" :label="head.name" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed">
                      <template slot-scope="scope">
                        <div v-if="head.imgUrl">
                          <img style="width:40px;height:40px" :src="gfUrl+scope.row[head.imgUrl]">
                        </div>
                         <p
                          v-else-if="head.format"
                          class="row_text"
                          >{{head.format(scope.row[head.attr])}}</p>
                        <div v-else>
                          <p v-if="head.filter" class="row_text">{{scope.row[head.attr] | switchType(head.filter[0],head.filter[1])}}</p>
                          <p v-else class="row_text">{{scope.row[head.attr]}}</p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="head.date" :prop="head.date" :label="head.name" :width="head.width" :fixed="hindex === 0 ? 'left' : head.fixed"></el-table-column>
                    <el-table-column v-if="head.buttons" :fixed="head.fixed || 'right'" label="操作" :width="head.width">
                    <template slot-scope="scope">
                        <span v-for="btn in head.buttons">
                        <el-button @click="btn.event(scope.row)" v-show="btn.show || true" type="text" :style="{color:btn.name==='删除'?'red':''}" size="small">{{btn.name}}</el-button>
                        <!-- <el-button @click="btn.event(scope.row)" :type="btn.type" size="mini">{{btn.name}}</el-button> -->
                        </span>
                    </template>
                    </el-table-column>
                </div>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name:'vSimpleTable',
    props:{
      tables:{
        type:Object,
        default:function(){
          return {
            tbody:[]
          }
        }
      },
      tabHeight:{//table高度
        type:[Number,String]
      },
      tableLoading:{
        type:Boolean,
        default:false
      },
      selectData:{//选中的数据
        type:Array
      },
      haveSearch:{//页面是否有搜索组件
        type:Boolean,
        default:true
      },
      haveScroll:{
        type:Boolean,
        default:false
      }
    },
    data(){
        return {
          gfUrl: global.fileUrl,
          selectItems: [],
          exportIcon: require('../assets/export.png'),
          delIcon: require('../assets/clear.png'),
          editIcon: require('../assets/edit.png'),
          printIcon: require('../assets/printing.png'),
          moreIcon: require('../assets/more.png'),
          mouseIn: -1,
        }
    },
    mounted() {
    },
    watch:{
      selectData:function(val){
        if(val.length <= 0){
          this.selectItems = []
        }
      }
    },
    computed:{
      tableHeight(){
        let iHeight = this.haveSearch ? window.innerHeight - 200 : window.innerHeight - 160;
        return iHeight;
      },
    },
    methods:{
      sort(data){
        if(this.tables.sortevent){
          this.tables.sortevent(data)
        }
      },
      handleSelectionChange(val){
        this.$emit('up-data',val)
        this.selectItems = val
      },
      mouseIsIn(boo,index){
          if(boo){
              this.mouseIn = index
          }else{
              this.mouseIn = -1
          }
      },
    }
}
</script>

<style scoped>
.el-table td, .el-table th{
  font-size: 12px;
  padding:0!important;
}
.operation{
    height: 39px;
    line-height: 39px;
    padding-left: 10px;
    border: 1px solid #E7E7E7;
    border-bottom: none;
}
.operation>div{
  float: left;
}
.add_item{
  padding: 10px;
  width: 350px;
}
.add_item>li{
  height: 50px;
  line-height: 50px;
  /* float: left; */
}
.add_item>li>input{
  width: 250px;
}
.add_item>li>span{
  display: inline-block;
  width: 50px;
  text-align: right;
  padding: 0 10px;
}
.add_buttons{
  width: 100%;
  padding-bottom: 10px;
  text-align: center;
}

.options_icon{
    position: relative;
    height: 24px;
    margin-top: 6px;
    width: 40px; 
    border-radius: 2px;
    border: 1px solid #E7E7E7;
}
.options_icon>.icons{
  cursor: pointer;
  height: 100%;
  background-color: #F6F6F6;
}
.options_icon>.icons>i{
    display: inline-block;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 5px;
    left: 13px;
}
.options_name{
    min-width: 40px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    position: absolute;
    top: -30px;
    left: 0;
    background-color: #2E2E2E;
    border-radius: 2px;
    color: #fff;
    overflow: hidden;
    white-space:nowrap;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/simpleTable.vue